import cacheLs from "../cacheLs"

export default {
  addQuizType (state, data) {
    state.selectedQuizType = { ...data }
    cacheLs.set_quiz_type(data)
  }
}
